import { Button, Modal } from 'react-bootstrap';
import { IoStarOutline, IoStarSharp } from 'react-icons/io5';
import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { Checkbox } from '@mui/material';
import Rating from '@mui/material/Rating';

import { styled } from '@mui/material/styles';
import { IReview } from '../../../../../../model/measure/IReview';
import { MeasureService } from '../../service';
import { ErrorToast, SuccessToast, WarningToast } from '../../../../../../utils/toasters';
import { useTranslation } from 'react-i18next';

const StyledRating = styled(Rating)({});

interface IReviewModal {
    show?: boolean;
    closeModal?: () => void;
    offerId: number;
}

export const LeaveReviewModal = ({ show, closeModal, offerId }: IReviewModal) => {
    const { t } = useTranslation();
    const [leaveReview, setLeaveReview] = useState<IReview>({
        offerId: 0,
        comment: '',
        communication: 0,
        timeOfDelivery: 0,
        contentQuality: 0,
        isContentAttached: false,
    });

    function createReview() {
        if (leaveReview.communication > 0 || leaveReview.contentQuality > 0 || leaveReview.timeOfDelivery > 0) {
            MeasureService.leaveReview({ ...leaveReview, offerId: offerId as number })
                .then(response => {
                    SuccessToast(t('general.toasts.reviewSubmitted'));
                    setLeaveReview(response);
                    closeModal && closeModal();
                })
                .catch(err => ErrorToast(err));
        } else {
            WarningToast(t('general.toasts.leaveReview'));
        }
    }

    function leaveCommentHandler(event: React.ChangeEvent<HTMLTextAreaElement>) {
        setLeaveReview({ ...leaveReview, [event.target.name]: event.target.value });
    }

    return (
        <Modal centered show={show} onHide={closeModal}>
            <Modal.Header id="close" closeButton className="px-3 pt-3 pb-0 ">
                <h4 className="fw-bold border-bottom pb-3 w-100">
                    {t('brand.campaign.dashboard.measure.leave_review')}
                </h4>
            </Modal.Header>
            <Modal.Body className="p-3">
                <div className="d-flex align-items-center">
                    <StyledRating
                        name="communication"
                        defaultValue={leaveReview.communication}
                        onChange={(event, newValue) => {
                            setLeaveReview({ ...leaveReview, communication: newValue as number });
                        }}
                        icon={<IoStarSharp className="rating-icon-bg" />}
                        emptyIcon={<IoStarOutline className="rating-icon-bg" />}
                    />
                    <div className="d-flex position-relative align-items-center">
                        <div className="ml-3 ">{t('brand.campaign.dashboard.measure.communication')}</div>
                        <span className="requested ml-2">{t('brand.campaign.dashboard.measure.requested')}</span>
                    </div>
                </div>
                <div className="d-flex align-items-center my-3">
                    <StyledRating
                        name="timeOfDelivery"
                        defaultValue={leaveReview.timeOfDelivery}
                        onChange={(event, newValue) => {
                            setLeaveReview({ ...leaveReview, timeOfDelivery: newValue as number });
                        }}
                        icon={<IoStarSharp className="rating-icon-bg" />}
                        emptyIcon={<IoStarOutline className="rating-icon-bg" />}
                    />
                    <div className="d-flex position-relative align-items-center">
                        <div className="ml-3 ">{t('brand.campaign.dashboard.measure.time_delivery')}</div>
                        <span className="requested ml-2 ">{t('brand.campaign.dashboard.measure.requested')}</span>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <StyledRating
                        name="contentQuality"
                        defaultValue={leaveReview.contentQuality}
                        onChange={(event, newValue) => {
                            setLeaveReview({ ...leaveReview, contentQuality: newValue as number });
                        }}
                        icon={<IoStarSharp className="rating-icon-bg" />}
                        emptyIcon={<IoStarOutline className="rating-icon-bg" />}
                    />
                    <div className="d-flex position-relative align-items-center">
                        <div className="ml-3 ">{t('brand.campaign.dashboard.measure.content_quality')}</div>
                        <span className="requested ml-2 ">{t('brand.campaign.dashboard.measure.requested')}</span>
                    </div>
                </div>
                <TextField
                    onChange={leaveCommentHandler}
                    multiline
                    minRows={4}
                    label={t('brand.campaign.dashboard.measure.leave_comment')}
                    variant="outlined"
                    size="small"
                    name="comment"
                    className="w-100 my-4 "
                />
                <div className="d-flex align-items-center">
                    <Checkbox
                        size={'small'}
                        id="isContentAttached"
                        color="primary"
                        onChange={e => {
                            setLeaveReview({ ...leaveReview, isContentAttached: e.target.checked });
                        }}
                    />
                    <label className="m-0 cursor-pointer" htmlFor="isContentAttached">
                        {t('brand.campaign.dashboard.measure.include_posting_files')}
                    </label>
                </div>
            </Modal.Body>
            <Modal.Footer className="p-3">
                <Button onClick={createReview} type="button" className="btn-primary btn-sm">
                    SUBMIT REVIEW
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
